module.exports = __webpack_public_path__ + "static/fonts/open-sans-v34-latin-regular.600270a4.woff";